var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHealthIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2831 0.500843C13.1403 0.477964 12.0376 0.92186 11.2294 1.73015C10.4211 2.5384 9.97721 3.64107 10.0001 4.78388C10.0229 3.64107 9.57905 2.5384 8.77076 1.73015C7.96251 0.921896 6.85984 0.477986 5.71703 0.500843C5.71703 0.500843 0.000488281 0.500843 0.000488281 7.65054C0.000488281 7.65054 0.000488281 16.2166 10.0001 20.5C19.9996 16.217 19.9996 7.65054 19.9996 7.65054C19.9996 0.500843 14.2831 0.500843 14.2831 0.500843ZM14.9999 12.1668H11.6666V15.5001H8.33356V12.1668H5.00028V8.83378H8.33356V5.50049H11.6669V8.83378H15.0001L14.9999 12.1668Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthIcon);
export default __webpack_public_path__ + "static/media/HealthIcon.f4eddbd57217f9bf5cdf99be814deb72.svg";
export { ForwardRef as ReactComponent };